// extracted by mini-css-extract-plugin
module.exports = {"container":"LegalPage_container__1hbf2","logo":"LegalPage_logo__1x03A"};